import { render, staticRenderFns } from "./CreateXLetterModal.vue?vue&type=template&id=5187005c&"
import script from "./CreateXLetterModal.vue?vue&type=script&lang=js&"
export * from "./CreateXLetterModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateXLetterModal.vue?vue&type=style&index=0&id=5187005c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports